/** Three lines that "fill in" as `progress` advances from 0 to 1. Matches
 *  design-handoff/project/screens-meeting.jsx:SkeletonLines.
 */
export function SkeletonLines({
  count = 3,
  progress,
  color,
}: {
  count?: number;
  /** 0..1 fill ratio */
  progress: number;
  /** Color token name (without leading `--`); e.g. "aws". */
  color: string;
}) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      {Array.from({ length: count }).map((_, i) => {
        const widthPct = [100, 92, 78][i % 3];
        const fillPct = Math.max(0, progress * 100 - i * 8);
        return (
          <div
            key={i}
            style={{
              height: 6,
              borderRadius: 3,
              background: `linear-gradient(90deg,
                var(--${color}-tint) 0%,
                var(--${color}-tint) ${fillPct}%,
                var(--paper-3) ${fillPct}%,
                var(--paper-3) 100%)`,
              width: `${widthPct}%`,
            }}
          />
        );
      })}
    </div>
  );
}
